import { Box, Container, Grid, Button } from "@mui/material";
import React, { useCallback, useState } from "react";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreCard from "../../../app/core/components/CoreCard/CoreCard";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import Dropzone from "react-dropzone";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import { toast } from "react-toastify";
import { LOGO_UPLOAD_MAX_SIZE } from "../../../utils/constants";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import { doUploadLogoFileOnS3 } from "./altriServiziSlide";
import { useDispatch } from "react-redux";
import {
  useEditServiceMutation,
  useGetUploadURLQuery,
} from "../../api/admin/altriServiziApi";

const CARTEGORY_LIST = [
  { label: "FINANZIARI", value: "FINANZIARI" },
  { label: "PIANIFICAZIONE FISCALE", value: "PIANIFIC_FISCALE" },
  { label: "ASSISTENZA PREVIDENZIALE", value: "ASSIST_PREVIDENZIALI" },
];

const EditService = ({ service, handleClose }) => {
  const [file, setFile] = useState({
    dropLogo: "",
    logoFile: null,
  });

  const [validationErrors, setValidationErrors] = useState({
    name: "",
    category: "",
  });
  const [formData, setFormData] = useState({
    name: service.name,
    category: service.category,
    description: service.description,
    iconUrl: service.iconUrl,
    website: service.website,
    commission: service.commission,
    enabled: service.enabled,
  });

  const { data: urlData, refetch: refetchImgUrlForUpload } =
    useGetUploadURLQuery();
  const [editService, { isLoading: isLoadingEdit }] = useEditServiceMutation();

  const dispatch = useDispatch();

  const uploadIMG = async () => {
    const linkURL = urlData.Data;
    let clearURL = "";
    if (linkURL) {
      const uploadFileUrl = linkURL;
      await dispatch(
        doUploadLogoFileOnS3({
          url: uploadFileUrl,
          file: new Blob([file.logoFile]),
          type: file.logoFile.type,
        })
      ).then((res) => {
        if (res.payload && res.payload.Exception) {
          toast.error(res.payload.Exception);
        } else {
          toast.success("Immagine caricata");
        }
      });
      clearURL = uploadFileUrl.split("?")[0];
      setFormData({
        ...formData,
        iconUrl: clearURL,
      });
    }
    return clearURL;
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const logoFile = file;
      setFile((prevValue) => ({
        ...prevValue,
        logoFile: logoFile,
      }));
      const reader = new FileReader();
      reader.onload = () => {
        if (file.size > LOGO_UPLOAD_MAX_SIZE) {
          toast.warning("Il file è troppo grande");
        } else {
          setFile((prevValue) => ({
            ...prevValue,
            dropLogo: reader.result,
          }));
        }
      };
      reader.readAsDataURL(file);
    });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setValidationErrors({ ...validationErrors, [name]: "" });
  };

  const handleEdit = async () => {
    const errors = {};
    if (!formData.name) errors.name = "Campo obbligatorio.";
    if (!formData.category) errors.category = "Campo obbligatorio.";
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    const imgUrl = file.logoFile ? await uploadIMG() : "";
    const editedService = {
      ...formData,
      id: service.id,
      iconUrl: imgUrl || formData.iconUrl,
    };
    editService(editedService).then((res) => {
      if (res?.data?.Exception) {
        toast.error(`Impossibile modificare il servizio`);
        return;
      }
      refetchImgUrlForUpload();
      toast.success("Servizio modificato", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
      });
      handleClose();
    });
  };

  const handleDeleteImage = () => {
    setFile({
      dropLogo: "",
      logoFile: null,
    });
    setFormData((formData) => ({ ...formData, iconUrl: "" }));
  };

  return (
    <Container>
      <Box pb={6}>
        <h2 className="fw-bold text-center">Modifica servizio</h2>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={6} display="flex" flexDirection="column">
          <h3 className="fw-bold">Inserisci dati</h3>
          <CoreSelectObjArr
            name="category"
            label="Categoria"
            value={formData.category}
            items={CARTEGORY_LIST || []}
            onChange={handleInputChange}
            error={Boolean(validationErrors.category)}
            helperText={validationErrors.category}
            required={true}
            className="w-full"
          />
          <CoreInputField
            label="Servizio"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            fullWidth
            required
            error={Boolean(validationErrors.name)}
            helperText={validationErrors.name}
          />
          <CoreInputField
            label="Sito web"
            name="website"
            value={formData.website}
            onChange={handleInputChange}
            fullWidth
          />

          <CoreInputField
            label="Commissione"
            type="text"
            name="commission"
            value={formData.commission}
            onChange={handleInputChange}
          />

          <Grid pt={4} item display="flex" flexDirection="column">
            <h3 className="fw-bold">Inserisci logo</h3>
            <div className="relative p-2 w-5/12">
              <CoreCard
                width={"10rem"}
                height={"10rem"}
                child={
                  formData.iconUrl || file.logoFile ? (
                    <>
                      <img
                        alt="logo"
                        src={formData.iconUrl || file.dropLogo}
                        style={{
                          maxWidth: "100px",
                          maxHeight: "100px",
                          paddingTop: "30px",
                        }}
                      />
                      <div>
                        <Button
                          onClick={handleDeleteImage}
                          className="absolute top-0 right-0 bg-red-500 text-white rounded-full"
                        >
                          x
                        </Button>
                      </div>
                    </>
                  ) : (
                    <Dropzone onDrop={onDrop}>
                      {({ getRootProps, getInputProps }) => (
                        <div
                          {...getRootProps()}
                          style={{
                            paddingTop: "20px",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                        >
                          <input {...getInputProps()} />

                          <Box display="flex" flexDirection="column">
                            <CoreButtonIcon
                              icon={
                                <UploadFileRoundedIcon
                                  className="text-gray"
                                  sx={{ fontSize: 70 }}
                                />
                              }
                            />
                          </Box>
                        </div>
                      )}
                    </Dropzone>
                  )
                }
              />
            </div>
          </Grid>
        </Grid>

        <Grid item xs={6} display="flex" flexDirection="column">
          <h3 className="fw-bold">Descrizione</h3>
          <Box display="flex" flexDirection="column" pt={3}>
            <CoreTextArea
              label="inserisci testo"
              type="text"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows={5}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid pt={5}>
        <CoreButton
          var="contained"
          className="btn btn-round"
          testo={isLoadingEdit ? "attendere" : "salva"}
          onClick={handleEdit}
          disabled={isLoadingEdit}
        />
      </Grid>
    </Container>
  );
};

export default EditService;
